export const TEST_ID = 'serviceRecordDetail';

export const BACK_TEST_ID = 'serviceRecordDetailBack';

export const DETAIL_ROW_TEST_ID = 'serviceRecordDetailRow';

export const EDIT_TEST_ID = 'serviceRecordDetailEdit';

export const PHOTOS_TEST_ID = 'serviceRecordDetailPhotos';
